import { render, staticRenderFns } from "./VidentiIcon.vue?vue&type=template&id=75f1bd89&scoped=true&"
import script from "./VidentiIcon.vue?vue&type=script&lang=js&"
export * from "./VidentiIcon.vue?vue&type=script&lang=js&"
import style0 from "./VidentiIcon.vue?vue&type=style&index=0&id=75f1bd89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f1bd89",
  null
  
)

export default component.exports